import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import networks from './networks';
import auth from './auth';
import backlogs from './backlogs';
import sites from './sites';
import toastr from './toastr';
import users from './users';
const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  networks,
  auth,
  backlogs,
  sites,
  toastr,
  users,
});

export default createRootReducer;
